import { CheckBox, MultipleSelect, TextInput } from "@normasteaching/norma-ui";
import { PropsWithChildren } from "react";
import { PaymentMethodConfigComponentProps } from "./PaymentMethodConfiguration.ts";
import { Controller } from "react-hook-form";

function InputWithLabel({
  children,
  label,
}: PropsWithChildren<{ label: string }>) {
  return (
    <div className={"flex flex-col gap-1 flex-1"}>
      <label className={"font-medium"}>{label}</label>
      {children}
    </div>
  );
}

export function StripeConfigFields({
  fieldName,
  register,
  errors,
  control,
  watch,
}: PaymentMethodConfigComponentProps) {
  const configErrors = errors[fieldName as keyof typeof errors] as unknown as {
    succeededUrl: { message: string };
    failedUrl: { message: string };
    allowedTerms: { message: string };
    paymentTypeError: { message: string };
  };

  const installmentsEnabled = watch(`${fieldName}.installmentsEnabled`);

  return (
    <div className="bg-blue-50 p-4 rounded-lg space-y-4">
      <InputWithLabel label="URL di successo">
        <TextInput
          {...register(`${fieldName}.succeededUrl`)}
          errorMessage={configErrors?.succeededUrl?.message}
          placeholder="es: https://fluentepersempre.normasteaching.com/buyer-thank-you"
        />
      </InputWithLabel>
      <InputWithLabel label="URL di fallimento">
        <TextInput
          {...register(`${fieldName}.failedUrl`)}
          errorMessage={configErrors?.failedUrl?.message}
          placeholder="es: https://fluentepersempre.normasteaching.com/buyer-failed"
        />
      </InputWithLabel>
      <div>
        <div className="flex gap-4 items-center">
          <Controller
            name={`${fieldName}.installmentsEnabled`}
            control={control}
            render={({ field }) => (
              <CheckBox
                value={field.value ?? false}
                onChange={field.onChange}
                label="Abilita pagamento a rate"
              />
            )}
          />
          <Controller
            name={`${fieldName}.oneTimeEnabled`}
            control={control}
            render={({ field }) => (
              <CheckBox
                value={field.value ?? false}
                onChange={field.onChange}
                label="Abilita pagamento in soluzione unica"
              />
            )}
          />
        </div>
        {configErrors?.paymentTypeError?.message && (
          <p className="text-red-600 text-sm mt-2">
            {configErrors.paymentTypeError.message}
          </p>
        )}
      </div>

      <InputWithLabel label={"Rate disponibili"}>
        <Controller
          {...register(`${fieldName}.allowedTerms`)}
          control={control}
          render={({ field }) => {
            return (
              <MultipleSelect
                errorMessage={configErrors?.allowedTerms?.message}
                searchable
                disabled={!installmentsEnabled}
                value={
                  field.value?.map((v: number): string => v.toString()) ?? []
                }
                onChange={(v) => {
                  return field.onChange(v.map((s) => parseInt(s, 10)));
                }}
                options={Array.from(
                  {
                    length: 22,
                  },
                  (_, i) => ({
                    id: (i + 3).toString(),
                    label: `${i + 3} rate`,
                  }),
                )}
              />
            );
          }}
        />
      </InputWithLabel>
    </div>
  );
}
